import styled from 'styled-components'
import Text from '../atoms/Text'
import WeeklyCalendar from './WeeklyCalendar'
import ConversationItem from './ConversationItem'
import { useState } from 'react'
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { useNavigate } from 'react-router-dom'
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px
`
const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const ViewAllButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
`
const ArrowIcon = styled(KeyboardArrowRightRoundedIcon)`
  color: ${(props) => props.theme.colors.text.assistive};
`
const EmptyMessage = styled.div`
  width: 100%;
  padding: 16px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border-radius: 10px;
`
const WeeklyActivity = ({ weeklyDatas, defaultSelectedDay }) => {
  const [selectedDay, setSelectedDay] = useState(defaultSelectedDay);
  const weeklyCounts = weeklyDatas.totalConversationNum;
  const conversationsOfDay = weeklyDatas.weeklyActivity[selectedDay] ?? []
  const navigate = useNavigate();
  const handleNavigate = (item) => {
    const { hrId } = item;
    navigate(`/conversations/${hrId}`)
  }

  return (
    <Container>
      <TitleWrapper>
        <Text variant="headline2" weight="bold">주간 대화 활동</Text>
        <ViewAllButton onClick={() => navigate('/conversations')}>
          <Text variant="body2" weight="medium" color="assistive">전체보기</Text>
          <ArrowIcon sx={{ fontSize: 20 }}/>
        </ViewAllButton>
      </TitleWrapper>
      <WeeklyCalendar weeklyCounts={weeklyCounts} selectedDay={selectedDay} onSelect={setSelectedDay}/>
      {conversationsOfDay.length === 0 ? (
        <EmptyMessage>
          <Text variant="body2" color="alternative">
            기록한 대화가 없어요.
          </Text>
        </EmptyMessage>
      ) : (
        conversationsOfDay.map((item) => (
          <ConversationItem key={item.hrId} data={item} onClick={() => handleNavigate(item)}/>
        ))
      )}
    </Container>
  )
}

export default WeeklyActivity
